import "./Logo.css";

const Logo = () => (
  <svg viewBox="0 0 66.145836 60.854164" version="1.1" className="logo">
    <g transform="translate(-34.708991,-35.630384)">
      <path
        d="m 181.18359,134.66602 v 50 h 50 v -50 z m 100,0 v 50 h 50 v -50 z m -150,80 v 50 h 50 v 50 50 h 50 v -50 -50 h 50 v 50 50 h 50 v -50 -50 h 50 v -50 h -50 -50 -50 -50 z"
        transform="scale(0.26458333)"
      />
    </g>
  </svg>
);

export default Logo;
